import React, { useState } from 'react';

function Test() {
  const [startDate, setStartDate] = useState([null, null]);

  return (
    <div>
      {/* <ReactDatePicker
        startDate={startDate?.[0]}
        endDate={startDate?.[1]}
        onChange={(dates) => setStartDate(dates)}
        monthsShown={2}
        placeholderText="Select Date in a Range"
        selectsRange
        inputProps={{
          clearable: true,
          onClear: () => setStartDate([null, null]),
        }}
      /> */}
    </div>
  );
}

export default Test;
